
export default {
  pending_quotations: [],
  sumal_dashboard: [],
  transactionsocol:[],
  dashboardocollist:[],
  dashboardocolsum:[],
  dashboardharvestingtotalarchived:[],
  dashboardharvestingarchived:[],
  dashboardharvestingtotalinprogress:[],
  dashboardharvestinginprogress:[],
  existingtransport:[],
  transportnew:[],
  transportontheroad: [],
  transportontheroadentrant: [],
  transporttoday:[],
  transportentranttoday:[],
  transportwaitingfordeparture:[],
  transportwaitingfordepartureentrant:[],
  transport: [],
  valueunpaidinvoice: [],
  unpaidinvoice: [],
  quotation_dashboard: [],
  quotation_dashboard_product:[],
  quotation_dashboard_product_print:[],
  quotation_dashboard_product_print_v2:[],
  quotation_dashboard_product_print_v3:[],
  quotationvolumetotal:[],
  kpi:[],
  unpaidinvoiceprovider:[],
  unpaidinvoiceprovidersum:[],
  eFacturaToBeSent: [],
  eFacturaReceived:  [],
  // Casa de marcat (bons fiscaux Datecs). `fiscalVatGroups` a 0 signifie que
  // la correspondance GRTVA -> taux n'est pas declaree : aucun bon ne peut
  // sortir, et la tuile doit le dire au lieu de laisser croire que tout va bien.
  fiscalPending: 0,
  fiscalIndeterminate: 0,
  fiscalVatGroups: 0,
  // Agent CasaMarcat. `fiscalAgentBlocking` n'est vrai que si des bons
  // attendent ET que personne ne les collecte : un agent silencieux sans file
  // est normal (il ne tourne en continu qu'en mode serve).
  fiscalAgentBlocking: false,
  fiscalAgent: null,
  // Etat du rapport Z (GET /fiscal/counts, cle `z`). null tant que non charge.
  fiscalZ: null,
  // Etat de la caisse elle-meme (cle `register` de /fiscal/counts).
  fiscalRegister: null,
  solarStations: [],
  solarRealtime: {},
  solarHistory: [],
  solarHistoryDay: [],
  solarForecast: null,
  solarScores: [],
  solarWorstScore: null,
  solarCriticalAlerts: { count: 0, items: [] },
}
 